export default "__VITE_ASSET__070a4d17__"